// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const ThermostatSLT3 = ({ fill, svgComponents: { Circle, G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    /*eslint-disable max-len */
    return (
        <G {...gProps}>
            <Path d="M20,25.45a6.77,6.77,0,1,1,6.77-6.77A6.77,6.77,0,0,1,20,25.45Zm0-12.53a5.77,5.77,0,1,0,5.77,5.77A5.77,5.77,0,0,0,20,12.92Z" />
            <Path d="M33.52,36h-27A2.48,2.48,0,0,1,4,33.52v-27A2.48,2.48,0,0,1,6.48,4h27A2.48,2.48,0,0,1,36,6.48v27A2.48,2.48,0,0,1,33.52,36ZM6.48,5A1.48,1.48,0,0,0,5,6.48v27A1.48,1.48,0,0,0,6.48,35h27A1.48,1.48,0,0,0,35,33.52v-27A1.48,1.48,0,0,0,33.52,5Z" />
            <Circle cx="28.9" cy="30.22" r="1.98" />
            <Circle cx="20" cy="30.22" r="1.98" />
            <Circle cx="11.1" cy="30.22" r="1.98" />
        </G>
    );
    /*eslint-enable max-len */
};

export default ThermostatSLT3;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/devices/thermostat-slt3/index.js